import { useQuery } from 'react-query';
import * as config from '../../../app.config';
import { setHeaders } from '../../../actions/User';
import axios from 'axios';

const getAutoDGPlates = async () => {

    const headerConfig = setHeaders();

    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qc/list_dg`, {
        headers: headerConfig
    });

    return data;
}

export default function useFetchAutoDGPlates() {
    return useQuery("autodgplates", getAutoDGPlates);
};